var _defs, _g, _path, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperatorDeviceLayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-change-layout-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-change-layout-1, .cls-change-layout-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-change-layout-1, .cls-change-layout-2, .cls-change-layout-3 {\n        fill: none;\n        stroke-width: 2px;\n      }\n\n      .cls-change-layout-2, .cls-change-layout-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-change-layout-3",
    d: "m16.73,26.12h7.76v4.9c0,1.58-1.28,2.86-2.86,2.86h-4.9v-7.76h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-change-layout-3",
    x: 8.97,
    y: 26.12,
    width: 7.76,
    height: 7.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-change-layout-3",
    x: 16.73,
    y: 18.36,
    width: 7.76,
    height: 7.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-change-layout-3",
    x: 8.97,
    y: 18.36,
    width: 7.76,
    height: 7.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-change-layout-3",
    d: "m16.73,10.6h4.9c1.58,0,2.86,1.28,2.86,2.86v4.9h-7.76v-7.76h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-change-layout-3",
    x: 8.97,
    y: 10.6,
    width: 7.76,
    height: 7.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-change-layout-3",
    d: "m4.06,10.6h4.9v23.28h-4.9c-1.58,0-2.86-1.28-2.86-2.86V13.46c0-1.58,1.28-2.86,2.86-2.86Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-change-layout-2",
    d: "m31.32,17.58v-5.96h0c0-4.29-3.47-7.76-7.76-7.76h-5.9"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-change-layout-1",
    points: "34.04 15.22 31.32 17.95 28.6 15.22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorDeviceLayout);
export default __webpack_public_path__ + "static/media/operator_device_layout.1eeac5b61b1ccf302d9031a58c719ed6.svg";
export { ForwardRef as ReactComponent };